import { PROFILE_PAGE_TYPES } from '@common/types';
import { useProfileContext } from '@components/Contexts/ProfileContext';

const useProfileContactButton = () => {
  const {
    partnerProfile,
    isMyProfile,
    enabled,
    isRenderedInModal,
    profilePageType,
  } = useProfileContext();

  // TODO: remove when usePublicPartnerProfiles spec is merged
  const shouldRenderContactButtonWithoutPageType =
    !isMyProfile && enabled && !isRenderedInModal;

  const havePageType = Boolean(profilePageType);

  const useMailToButton = profilePageType === PROFILE_PAGE_TYPES.agency;
  const email = partnerProfile?.professionalInformation?.email;

  return {
    isMyProfile,
    havePageType,
    shouldRenderContactButtonWithoutPageType,
    useMailToButton,
    email,
  };
};

export default useProfileContactButton;
